// A YouTube link becomes its video still; anything else is returned as-is.
export function youtubeThumb(value) {
  const match = String(value ?? "").match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([\w-]{11})/);
  return match ? `https://i.ytimg.com/vi/${match[1]}/hqdefault.jpg` : value;
}
